<template>
  <div>
    <div class="card top-draft">
      <div class="">
        <!-- <div class="col-lg-12" v-if="power['添加']">
          <b-button variant="primary" @click="toCreate()">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            新增
          </b-button>
        </div> -->

        <div class="col-lg-12 list-header pad-header-bg clearfix">
          <div class="header-item-fix">
            <b-form-input
              size="sm"
              type="text"
              v-model="pageParams.content"
              placeholder="请输入搜索内容"
              @keyup.enter.native="search"
            ></b-form-input>
            <b-button size="sm" variant="primary" @click="search()">
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
          <div class="header-item-fix">
            <b-form-input
              size="sm"
              type="text"
              v-model="pageParams.questionnaireContent"
              placeholder="请输入问卷ID或问卷名称"
              @keyup.enter.native="search"
            ></b-form-input>
          </div>
          <div class="header-item-fix">
            <el-date-picker
              style="max-width: 350px"
              size="mini"
              v-model="daterange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="center"
            >
            </el-date-picker>
          </div>
          <div class="header-item-fix">
            <b-form-select
              style="width: 100px"
              @change="search()"
              v-model="pageParams.state"
              class="form-select"
              :options="verifyStatus"
              type="text"
            ></b-form-select>
          </div>
          <div class="header-item-fix">
            <b-form-select
              style="width: 100px"
              @change="search()"
              v-model="pageParams.type"
              class="form-select"
              :options="statusList"
              type="text"
            ></b-form-select>
          </div>

          <b-button
            size="sm"
            v-if="power['添加']"
            variant="primary"
            @click="toCreate()"
          >
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            新增
          </b-button>
        </div>

        <div class="col-lg-12">
          <div class="table-responsive" v-loading="tableLoading">
            <table
              class="table table-nowrap table-centered table-striped align-middle"
            >
              <thead>
                <tr>
                  <th scope="col" style="width: 40px">
                    <b-form-checkbox
                      @change="checkedAll"
                      v-model="indeterminate"
                      checked
                      plain
                    ></b-form-checkbox>
                  </th>
                  <th scope="col" style="width: 70px">ID</th>
                  <th scope="col">题目标题</th>
                  <th scope="col">题目类型</th>
                  <th scope="col">关联问卷</th>
                  <th scope="col">状态</th>
                  <th scope="col">创建人/创建时间</th>
                  <th scope="col">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>
                    <b-form-checkbox
                      v-model="choiceListIds"
                      :value="item.id"
                      checked
                      plain
                    ></b-form-checkbox>
                  </td>
                  <td>{{ item.id }}</td>
                  <td class="w-300 white-inherit">{{ item.title }}</td>
                  <td>
                    {{ checkType(item.type) }}
                  </td>
                  <td class="w-300 white-inherit">
                    <div
                      style="margin-bottom: 2px"
                      v-for="(data, index) in item.questionnaires"
                      :key="index"
                    >
                      {{ data.title }}
                    </div>
                  </td>
                  <td>
                    <el-tooltip
                      v-if="power['显示/隐藏']"
                      :content="item.state == 1 ? '点击禁用' : '点击启用'"
                    >
                      <span
                        @click="modifyStatus(item, '0')"
                        v-if="item.state == 1"
                        class="dsply-fix status-open"
                        ><i></i>启用</span
                      >
                      <span
                        @click="modifyStatus(item, '1')"
                        v-if="item.state == 0"
                        class="dsply-fix status-off"
                        ><i></i>禁用</span
                      >
                    </el-tooltip>
                    <div v-if="!power['显示/隐藏']">
                      <span v-if="item.state == 1" class="dsply-fix status-open"
                        ><i></i>启用</span
                      >
                      <span v-if="item.state == 0" class="dsply-fix status-off"
                        ><i></i>禁用</span
                      >
                    </div>
                  </td>

                  <td>
                    {{ item.creator || "--" }}<br />{{ item.createdAt || "--" }}
                  </td>
                  <td>
                    <!-- <button
                      v-if="power['编辑']"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="toTopic(item)"
                    >
                      题目
                    </button>
                    <button
                      v-if="power['审核']"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="toPerformance(item)"
                    >
                      成绩数据
                    </button> -->
                    <button
                      v-if="power['编辑']"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="toDetail(item)"
                    >
                      编辑
                    </button>
                    <button
                      v-if="power['移除']"
                      type="button"
                      class="btn-sm btn btn-danger"
                      @click="remove(item)"
                    >
                      移除
                    </button>
                    <!-- </td> -->
                  </td>

                  <!-- 草稿：编辑详情、提交审核、删除
                待审核：查看、撤销、删除；展示预览链接
                驳回：编辑详情、提交审核、驳回原因、删除
                审核通过后-->
                </tr>
              </tbody>
            </table>
            <div v-if="!items || !items[0]" class="xb-table-noData">
              <span v-if="!tableLoading && !items[0]">暂无数据</span>
            </div>
          </div>
          <!-- :isBatch 如果有批量操作就传这个参数 没有就不传
          batchs 批量操作的列表
          pageCallback 分页组件的回调方法 -->
          <!-- <pagination
            ref="page"
            @pageCallback="pageCallback"
            
          ></pagination> -->
          <pagination
            class="bath_r_20"
            :total="pageTotal"
            :pageSize="pageParams.pageSize"
            :page.sync="pageParams.page"
            :pageSizes="[30, 50, 100]"
            isBatch
            :batchs="batchs"
            @pageCallback="pageCallback"
          ></pagination>
        </div>
      </div>
    </div>
    <question-modal @change="detailCallback" ref="detail"></question-modal>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";
import question from "@/server/api/question";
// import configure from "./plugins.js";
import QuestionModal from "../questionManage/newTopicDialog.vue";
import { changeList } from "@/util/fun.js";
/**
 * Contacts-list component
 */
export default {
  components: {
    DatePicker,
    QuestionModal,
  },

  data() {
    return {
      pageTotal: 0,
      power: "",
      choiceListIds: [], //当前所选择的id
      indeterminate: false, //全选
      pageParams: {
        page: 1,
        pageSize: 30,
        type: "",
        content: "",
        state: "",
        sortBy: "createdAt",
        questionnaireContent: "",
        order: "desc",
        deleted: false,
      },
      items: [],
      batchs: [
        //批量操作有哪些操作
        { text: "批量操作", value: "0" },
        // { text: "启用", value: "1" },
        // { text: "禁用", value: "2" },
        { text: "移除", value: "3" },
      ],
      statusList: [
        { text: "题目类型", value: "" },
        { text: "单选", value: 0 },
        { text: "多选", value: 1 },
        { text: "判断", value: 2 },
        { text: "排序", value: 5 },
        { text: "单选填空", value: 3 },
        { text: "多选填空", value: 4 },
      ],
      verifyStatus: [
        { text: "筛选状态", value: "" },
        { text: "启用", value: 1 },
        { text: "禁用", value: 0 },
      ],
      effectStatus: [
        { text: "生效状态", value: "" },
        { text: "生效中", value: "1" },
        { text: "待生效", value: "2" },
        { text: "已失效", value: "3" },
      ],
      daterange: "",
      radio: "",
      innerVisible: false,
      currentTopic: [],
      answersOption: [
        { text: "完全匹配得分", value: 0 },
        { text: "包含答案即可得分", value: 1 },
      ],
      answerList: [],
      answerTitle: "",
      visible: false,
      contentValue: "",
      index_id: null,
      tableLoading: false,
    };
  },

  watch: {
    choiceListIds: function() {
      if (
        this.choiceListIds.length == this.items.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
  },

  created() {
    if (this.$store.state.pageParams.questionBank) {
      this.pageParams = {
        ...this.pageParams,
        ...this.$store.state.pageParams.questionBank,
      };
      if (this.pageParams.startTime && this.pageParams.endTime) {
        this.daterange = [
          new Date(this.pageParams.startTime),
          new Date(this.pageParams.endTime),
        ];
      }
    }
    this.power = this.utils.currentPower("创作平台-题库管理");
    let obj = this.getCache("question-bank-list");
    if (obj && obj.list && obj.list[0]) {
      this.items = obj.list;
      this.pageTotal = obj.pageTotal;
    } else {
      this.getList();
    }
  },
  beforeDestroy() {
    this.$store.dispatch("pageParams/cacheQuestionBankParams", this.pageParams);
    this.addCache("question-bank-list", {
      list: this.items,
      pageTotal: this.pageTotal,
    });
  },
  methods: {
    //获取列表数据
    getList(showLoading) {
      let params = this.utils.getQuery(this.pageParams);
      // let params = this.pageParams;
      if (showLoading !== false) {
        this.tableLoading = true;
        this.items = [];
      }
      this.choiceListIds = [];
      question.questionList(params).then((resp) => {
        if (resp.code === 0 && resp.data) {
          this.tableLoading = false;
          if (resp.data.items) {
            this.items = resp.data.items;
            this.pageTotal = resp.data.total;
            this.updateCache("question-bank-list", {
              list: this.items,
              pageTotal: this.pageTotal,
            });
          }
        }
      });
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      if (obj.code === "pageSize") {
        //更改页码
        this.pageParams.pageSize = obj.ps;
        this.getList();
      }
      if (obj.code === "batch") {
        //处理批量操作
        if (obj.batch == "3") {
          if (this.choiceListIds.length) {
            //点击通过的处理方法
            this.remove();
          } else {
            Vue.swal("请选择要移除的内容");
            return;
          }
        }
      }
    },

    //添加
    toCreate() {
      this.$refs.detail.showModel();
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      if (this.daterange) {
        this.pageParams.startTime = this.daterange[0].format(
          "yyyy-MM-dd hh:mm:ss"
        );
        this.pageParams.endTime = this.daterange[1].format(
          "yyyy-MM-dd hh:mm:ss"
        );
      }
      this.getList();
    },
    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.pageSize = 30;

      this.pageParams.state = "";
      this.pageParams.type = "";
      this.pageParams.content = "";
      this.pageParams.verifyState = "";
      this.pageParams.questionnaireContent = "";

      this.daterange = "";
      delete this.pageParams.startTime;
      delete this.pageParams.endTime;
      this.getList();
    },

    // 列表全选
    checkedAll() {
      if (this.indeterminate) {
        this.choiceListIds = this.items.map((item) => item.id);
      } else {
        this.choiceListIds = [];
      }
    },
    //显示状态
    modifyStatus(item, status) {
      let title_text = status == 1 ? "确定启用？" : "确定禁用？";
      Swal.fire({
        title: title_text,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {
            id: item.id,
            title: item.title, //标题
            type: item.type, //封面
            state: Number(status), //0-禁用,1-启用
            caseSensitive: item.caseSensitive,
            casePunctuation: item.casePunctuation,
          };
          question.questionBase(params).then((resp) => {
            if (resp.code == 0) {
              let success_text = status == 1 ? "启用成功" : "禁用成功";
              Vue.swal({
                icon: "success",
                title: success_text,
                showConfirmButton: false,
                timer: 1000,
              });
              // this.getList();
              item.state = Number(status);
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },
    //删除
    remove(item) {
      Swal.fire({
        title: "确定删除?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = [];
          if (item) {
            params.push(item.id);
          } else {
            params = this.choiceListIds;
          }
          question.questionDelete(params).then((resp) => {
            if (resp.code == 0) {
              //删除成功时清空回收站缓存以刷新列表
              this.updateCache("question-bank-recycle", { list: "" });
              Vue.swal({
                icon: "success",
                title: "删除成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              // this.getList(); 删除数据时不调用列表接口,直接从列表删除对应内容
              if (this.items.length == params.length) {
                this.getList();
              } else {
                this.pageTotal -= params.length;
                this.items = changeList("delete", this.items, params, "id");
                if (!item) {
                  this.choiceListIds = [];
                }
              }
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },
    //判断类型
    checkType(num) {
      if (num == 0) {
        return "单选";
      }
      if (num == 1) {
        return "多选";
      }
      if (num == 2) {
        return "判断";
      }
      if (num == 3) {
        return "单项填空";
      }
      if (num == 4) {
        return "多项填空";
      }
      if (num == 5) {
        return "排序";
      }
    },

    //标签关闭
    handleTagClose(item) {
      item.content = "";
    },
    //编辑
    toDetail(item) {
      // this.index_id = item.id;
      // this.feat(item);
      this.$refs.detail.showModel(item);
    },
    feat(item) {
      question.questionDetail({ id: item.id }).then((res) => {
        if (res.code == 0) {
          this.dialogFormVisible = true;
          this.form = res.data;
          this.form.type = this.form.type + "";
          this.form.answers.forEach((v) => {
            v.isCorrect = v.isCorrect + "";
          });

          if (this.form.type == "3") {
            this.form.answers[0].scoreRule =
              this.form.answers[0].scoreRule == 1 ? true : false;
          }
          this.form.caseSensitive = this.form.caseSensitive == 1 ? true : false;
          this.form.casePunctuation =
            this.form.casePunctuation == 1 ? true : false;
          if (this.form.type == "4") {
            this.answerList = this.form.answers;
          }
        }
      });
    },
    toRadio(val, item, index) {
      if (this.form.type == 0 || this.form.type == 2) {
        this.form.answers.forEach((v) => {
          v.isCorrect = "";
        });
        this.form.answers[index].isCorrect = "1";
      }
    },
    //有附件时可以只有附件不要文字题目和文字答案
    checkForm() {
      let data = this.form;
      if (!data.title && !data.attachment) {
        this.warning("请填写题目或上传附件");
        return;
      }
      let arr = this.form.answers;
      let len = arr.length;
      let sort = [];

      if ([0, 1, 2, 5].indexOf(Number(this.form.type)) != -1) {
        for (let i = 0; i < len; i++) {
          if (!arr[i].content && !arr[i].attachment) {
            this.warning(`选项${i + 1}请填写文字答案或上传附件`);
            return;
          }
          if (this.form.type == 5) {
            //排序题需要验证排序值
            if (
              arr[i].questionSort === "" ||
              arr[i].questionSort === undefined
            ) {
              this.warning(`选项${i + 1}请填写排序值`);
              return;
            }
            let temp = Number(arr[i].questionSort);
            if (temp <= 0 || isNaN(temp) || temp != parseInt(temp)) {
              this.warning(`选项${i + 1}的排序值请填写大于0的整数`);
              return;
            }
            let index = sort.indexOf(temp);
            if (index != -1) {
              this.warning(
                `选项${i + 1}的排序值与选项${index + 1}的排序值重复`
              );
              return;
            }
            if (temp > len) {
              this.warning(`选项${i + 1}的排序值请填写不大于选项总数的整数`);
              return;
            }
            arr[i].sort = i;
            arr[i].scoreRule = 0;
            arr[i].questionSort = temp;
            arr[i].isCorrect = 1;
            sort.push(temp);
          }
        }
      }

      if (this.form.type == 5) {
        this.form.caseSensitive = 0;
        this.form.casePunctuation = 0;
        if (len < 2) {
          this.warning(`排序题至少有两个选项`);
          return;
        }
      }
      return true;
    },
    detailCallback(id) {
      if (id) {
        question.questionDetail({ id }).then((res) => {
          if (res.code === 0) {
            console.log("问答详情", res);
            let detail = res.data;
            detail.id = id;
            this.items = this.items.map((tr) => {
              if (tr.id == id) {
                return { ...tr, ...detail };
              } else {
                return tr;
              }
            });
          }
        });
      } else {
        this.getList(false);
      }
    },
  },
};
</script>

<style lang="scss">
.newTopic {
  .el-dialog__body {
    max-height: calc(100vh - 200px);
    overflow: auto;
  }
}
</style>
